import { render } from "./UnicodeDetector.vue?vue&type=template&id=67aa3b2a"
import script from "./UnicodeDetector.vue?vue&type=script&lang=js"
export * from "./UnicodeDetector.vue?vue&type=script&lang=js"

import "./UnicodeDetector.vue?vue&type=style&index=0&id=67aa3b2a&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__